import { Tooltip as MuiTooltip } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";

import styles from "./Tooltip.module.scss";

type TooltipProps = {
  copy?: string;
};

export const Tooltip = ({ copy }: TooltipProps): JSX.Element | null =>
  copy ? (
    <MuiTooltip title={copy} placement="top">
      <InfoIcon className={styles.icon} />
    </MuiTooltip>
  ) : null;
